import React from "react";

//Importar íconos de Material UI.
import { Image, InsertDriveFile, Mic, Label, Videocam } from '@mui/icons-material/';

//  MessageByTypeInInbox: Componente que renderiza el tipo de mensaje entrate en el inbox
// y el nombre del chat.

const MessageByTypeInInbox = ({ type, chat, idChat, idChatSeleccionado }) => {
    
    return (
        <div className={`card__name-wiht-message ${idChat === idChatSeleccionado ? 'active' : ''}`}>
            <span>{chat.Nombre}</span>

            {type === "text" && chat.Message !== null &&
                ((chat.Message.length > 22
                     ? <label>{chat.Message.slice(0, 18)}...</label> 
                     : <label>{chat.Message.slice(0, 22)}</label>)) 
            }

            {type === "image" &&
                (<label className="message-type-image__text">
                    <Image sx={{ marginRight: "5px" }} />
                    Imagen
                </label>)}

            {type === "document" &&
                (<label className="message-type-image__text"> 
                <InsertDriveFile sx={{ marginRight: "5px" }} />
                 Documento
                 </label>)}

            {type === "sticker" &&
                (<label className="message-type-image__text"> 
                <Label sx={{ marginRight: "5px" }} /> 
                Sticker
                </label>)}

            {type === "audio" &&
                (<label className="message-type-image__text">
                     <Mic sx={{ marginRight: "5px" }} />
                 Audio
                 </label>)}

            {type === "video" &&
                (<label className="message-type-image__text"> 
                <Videocam sx={{ marginRight: "5px" }} /> 
                Video
                </label>)}

        </div>
    )
};

export default MessageByTypeInInbox;